import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { EventComp } from "../../components/event/event.comp";
import { LoadingComp } from "../../components/loading/loading.comp";
import { useData } from "../../libs/data/app-data.hook";
import { Event } from "../../libs/data/event";

export const TaggedScheduleView = () => {
  const [searchParams] = useSearchParams();
  const tag = searchParams.get("tag");
  const { loading, activities } = useData();
  const schedule: Array<Event> = (activities?.schedule ?? []).filter(
    (activity: Event) => (tag ? activity.tags?.includes(tag) : true)
  );

  const mondayList = schedule
    .filter((event) => event.day === 1)
    .sort((a, b) => (a.startTime < b.startTime ? -1 : 0));
  const tuesdayList = schedule
    .filter((event) => event.day === 2)
    .sort((a, b) => (a.startTime < b.startTime ? -1 : 0));
  const wednesdayList = schedule
    .filter((event) => event.day === 3)
    .sort((a, b) => (a.startTime < b.startTime ? -1 : 0));
  const thursdayList = schedule
    .filter((event) => event.day === 4)
    .sort((a, b) => (a.startTime < b.startTime ? -1 : 0));
  const fridayList = schedule
    .filter((event) => event.day === 5)
    .sort((a, b) => (a.startTime < b.startTime ? -1 : 0));

  return (
    <div className="text-center">
      <div className="col-md-2">
        <h2>Monday</h2>
        {mondayList?.map((event) => (
          <EventComp key={event.id} event={event} />
        ))}
      </div>
      <div className="col-md-2">
        <h2>Tuesday</h2>
        {tuesdayList?.map((event) => (
          <EventComp key={event.id} event={event} />
        ))}
      </div>
      <div className="col-md-2">
        <h2>Wednesday</h2>
        {wednesdayList?.map((event) => (
          <EventComp key={event.id} event={event} />
        ))}
      </div>
      <div className="col-md-2">
        <h2>Thursday</h2>
        {thursdayList?.map((event) => (
          <EventComp key={event.id} event={event} />
        ))}
      </div>
      <div className="col-md-2">
        <h2>Friday</h2>
        {fridayList?.map((event) => (
          <EventComp key={event.id} event={event} />
        ))}
      </div>
      {loading && <LoadingComp />}
    </div>
  );
};
